import { ClinicalVisualization } from "./components/ClinicalVisualization/ClinicalVisualization";
import { EditQuestionnaireContextProvider } from "../../contexts/EditQuestionnaireContext";
import { LargeContentBox } from "@/components/common";
import { AttendanceTimer } from "./components/AttendanceTimer";

export function MedicalCare() {
  return (
    <LargeContentBox>
      <EditQuestionnaireContextProvider>
        {/* Timer flutuante baseado em Encounter.actualPeriod.start */}
        <AttendanceTimer />
        <ClinicalVisualization />
      </EditQuestionnaireContextProvider>
    </LargeContentBox>
  );
}
